<div formGroupName="tankatableConditionInfo">
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
        <mat-form-field appearance="outline"
            class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[28%] tw-md:max-w-[full]">
            <mat-label>会社</mat-label>
            <mat-select formControlName="companycode" (openedChange)="onSelectOpened('companycode', $event)" (selectionChange)="onChangeCompany()">
                <mat-option *ngFor="let companyType of companyTypeList" [value]="companyType.value">
                    {{companyType.viewValue}}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline"
            class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[13%] tw-md:max-w-[full]">
            <mat-label>エネルギー種別</mat-label>
            <mat-select formControlName="energyClscode" (openedChange)="onSelectOpened('energyClscode', $event)" (selectionChange)="onChangeEnergy()">
                <mat-option *ngFor="let energyType of energyTypeList" [value]="energyType.value">
                    {{energyType.viewValue}}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline"
            class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[13%] tw-md:max-w-[full]">
            <mat-label>ＬＰ販売形態</mat-label>
            <mat-select formControlName="lpSalesformcode" (openedChange)="onSelectOpened('lpSalesformcode', $event)" (selectionChange)="onChangeLpSalesForm()">
                <mat-option *ngFor="let lpSalesFormType of lpSalesFormTypeList" [value]="lpSalesFormType.value">
                    {{lpSalesFormType.viewValue}}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline"
            class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[28%] tw-md:max-w-[full]">
            <mat-label>承認部門</mat-label>
            <mat-select formControlName="apprvAuthorityCode" (openedChange)="onSelectOpened('apprvAuthorityCode', $event)" (selectionChange)="onChangeApproval()">
                <mat-option *ngFor="let approvalType of approvalTypeList" [value]="approvalType.value">
                    {{approvalType.viewValue}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
        <mat-form-field appearance="outline"
            class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[28%] tw-md:max-w-[full]">
            <mat-label>地点群／供給地点区分</mat-label>
            <mat-select formControlName="locationgroupSuppntDivisionnumber" (openedChange)="onSelectOpened('locationgroupSuppntDivisionnumber', $event)">
                <mat-option *ngFor="let chitenType of chitenTypeList" [value]="chitenType.value">
                    {{chitenType.viewValue}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
        <mat-form-field appearance="outline"
            class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[13%] tw-md:max-w-[full]">
            <mat-label>適用年月</mat-label>
            <input matInput formControlName="searchTargetYm" autocomplete="off" type="month">
        </mat-form-field>

        <mat-form-field appearance="outline"
            class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[13%] tw-md:max-w-[full]">
            <mat-label>ステータス</mat-label>
            <mat-select formControlName="apprvStatuscode">
                <mat-option *ngFor="let statType of statTypeList" [value]="statType.value">
                    {{statType.viewValue}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
<div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
    <mat-card-actions class="btn_area_right">
        <button type="submit" mat-raised-button color="primary" class="btn" (click)="onClickSearch()" id="search"
            [disabled]="parentForm.invalid || isSearchDisabled()">検索</button>
    </mat-card-actions>
    <mat-card-actions class="btn_area_right">
        <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickClear()"
            id="clear">クリア</button>
    </mat-card-actions>
</div>